"use client"

/**
 * Product shim over `@exxatdesignux/ui` outline-tree primitives.
 *
 * Adds `OutlineTreeExpandTrigger` so Collapsible open does not paint Button’s
 * `aria-expanded` selected wash (expand ≠ select). Use this for every tree
 * chevron instead of a raw ghost `Button`.
 *
 * Default size is `icon-xs` (size-6) so the chevron center matches
 * `--outline-tree-row-padding-x` + `--outline-tree-chevron-half` on the guide.
 */

import * as React from "react"

import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"

export * from "@exxatdesignux/ui/components/data-views/outline-tree-menu"

/** Expand control chrome — open stays transparent (library folder tree parity). */
export const OUTLINE_TREE_EXPAND_TRIGGER_CLASS =
  "bg-transparent text-muted-foreground shadow-none hover:bg-transparent hover:text-foreground active:bg-transparent focus-visible:bg-transparent aria-expanded:bg-transparent aria-expanded:text-muted-foreground data-[state=open]:bg-transparent data-[state=open]:text-muted-foreground"

export function OutlineTreeExpandTrigger({
  className,
  children,
  size = "icon-xs",
  ...props
}: React.ComponentProps<typeof Button>) {
  return (
    <Button
      type="button"
      variant="ghost"
      size={size}
      data-slot="outline-tree-expand"
      className={cn(OUTLINE_TREE_EXPAND_TRIGGER_CLASS, className)}
      {...props}
    >
      {children}
    </Button>
  )
}
